import Links from '@/shared/constants/navegacao';
import { TOKEN_KEY } from '@/shared/constants/strings';

const authSessionListeners = new Set<() => void>();

/** Avisa o app que o JWT mudou (login, logout ou 401) no mesmo separador. */
export function notifyAuthSessionChanged(): void {
  authSessionListeners.forEach((listener) => listener());
}

export function subscribeAuthSession(listener: () => void): () => void {
  authSessionListeners.add(listener);
  return () => {
    authSessionListeners.delete(listener);
  };
}

/** Remove o JWT da sessão (mantém demais preferências do `localStorage`). */
export function clearAuthSession() {
  if (localStorage.getItem(TOKEN_KEY) == null) return;
  localStorage.removeItem(TOKEN_KEY);
  notifyAuthSessionChanged();
}

/** Rotas públicas do portal do candidato (inscrição, confirmação, login por token). */
export const PUBLIC_CANDIDATE_ROUTE_PREFIXES = [
  Links.Candidato_Inscricao,
  Links.Candidato_Inscricao_Confirmacao,
  Links.Candidato_Login,
  Links.Candidato_Meus_Processos,
  Links.ProcessoSeletivo_NaoDisponivel,
] as const;

/** Rotas em que um 401 não deve redirecionar (evita loop na tela de login). */
const PUBLIC_AUTH_ROUTE_PREFIXES = [
  Links.Auth_Login,
  Links.Auth_Obter_Token,
  Links.Auth_Logout,
  Links.Recuperar,
  Links.Veirifique_Email,
  Links.TrocarSenha,
  ...PUBLIC_CANDIDATE_ROUTE_PREFIXES,
] as const;

function matchesRoutePrefix(path: string, prefix: string): boolean {
  const base = prefix.replace(/\/$/, '');
  return path === base || path.startsWith(`${base}/`);
}

export function isPublicCandidateRoute(pathname?: string): boolean {
  const path = (pathname ?? window.location.pathname).replace(/\/$/, '') || '/';
  return PUBLIC_CANDIDATE_ROUTE_PREFIXES.some((prefix) => matchesRoutePrefix(path, prefix));
}

export function isPublicAuthRoute(pathname?: string): boolean {
  const path = (pathname ?? window.location.pathname).replace(/\/$/, '') || '/';
  return PUBLIC_AUTH_ROUTE_PREFIXES.some((prefix) => matchesRoutePrefix(path, prefix));
}
